import React, { useState } from "react";
import Swal from "sweetalert2";
import { loginApiCall, otpApi } from "../../utils/api";

const Login = () => {
  const [step, setStep] = useState(1); // 1 = email login, 2 = phone + OTP
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [tempToken, setTempToken] = useState(null);
  const [tempMenu, setTempMenu] = useState(null);
  const [otpFieldEnabled, setOtpFieldEnabled] = useState(false);

  // Step 1: Handle Email/Password Login
  const handleLogin = async (e) => {
    e.preventDefault();

    const res = await loginApiCall("admin/login", {
      email: email,
      password: password,
      role: "admin, leveladmin",
    });

    if (!res.success) {
      Swal.fire("Login Failed", res.message, "error");
    } else {
      Swal.fire("Login Success", "Proceed with OTP verification", "success");

      // Save temporary token until OTP verified
      setTempToken(res.token);
      setTempMenu(res.sidebar);

      // Switch to Step 2
      setStep(2);
    }
  };

  // Step 2: Send OTP
  const handleSendOtp = async () => {
    if (!phone) {
      Swal.fire("Error", "Please enter phone number", "error");
      return;
    }

    const res = await otpApi("crm/send-otp", { phone, email });

    if (res.success) {
      Swal.fire("OTP Sent", "Please check your phone", "success");
      setOtpFieldEnabled(true); // lock phone + sendOtp, unlock OTP + Verify
    } else {
      Swal.fire("Error", res.message, "error");
    }
  };

  // Step 3: Verify OTP
  const handleVerifyOtp = async (e) => {
    e.preventDefault();

    const res = await otpApi("crm/verify-otp", {
      phone,
      otp,
    });

    if (res.success) {
      Swal.fire("Logged In successfully", "", "success");

      // Save token & sidebar
      localStorage.setItem("data", JSON.stringify(tempToken));
      localStorage.setItem("sidebarMenu", JSON.stringify(tempMenu));

      window.location.href = "/";
    } else {
      Swal.fire("Invalid OTP", res.message, "error");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <div className="login-box">
        <div className="card">
          <div className="card-body login-card-body">
            {step === 1 && (
              <>
                <p className="login-box-msg">Sign in to start your session</p>
                <form onSubmit={handleLogin} method="post">
                  <div className="input-group mb-3">
                    <input
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                      type="email"
                      className="form-control"
                      placeholder="Email"
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fas fa-envelope" />
                      </div>
                    </div>
                  </div>
                  <div className="input-group mb-3">
                    <input
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      type="password"
                      className="form-control"
                      placeholder="Password"
                    />
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fas fa-lock" />
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4">
                      <button
                        type="submit"
                        className="btn btn-primary btn-block"
                      >
                        Sign In
                      </button>
                    </div>
                  </div>
                </form>
              </>
            )}

            {step === 2 && (
              <>
                <p className="login-box-msg">Phone Verfication</p>
                <form onSubmit={handleVerifyOtp}>
                  <div className="input-group mb-3">
                    <input
                      onChange={(e) => setPhone(e.target.value)}
                      value={phone}
                      type="tel"
                      className="form-control"
                      placeholder="Phone Number"
                      disabled={otpFieldEnabled} 
                    />
                    <div className="input-group-append">
                      <button
                        type="button"
                        style={{ height: "50px" }}
                        className="btn btn-secondary"
                        onClick={handleSendOtp}
                        disabled={otpFieldEnabled} 
                      >
                        Send OTP
                      </button>
                    </div>
                  </div>
                  <div className="input-group">
                    <input
                      onChange={(e) => setOtp(e.target.value)}
                      value={otp}
                      type="text"
                      className="form-control"
                      placeholder="Enter OTP"
                      disabled={!otpFieldEnabled} // enable only after OTP sent
                    />
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={!otpFieldEnabled} // disable until OTP sent
                      >
                        Verify OTP
                      </button>
                    </div>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
